export default {
  title: 'Thank you for applying',
  subtitle:
    'An Account Manager will contact you shortly to discuss your application and next steps.',
  paragraph:
    'We work with a panel of partner lenders who offer a variety of products that could suit your needs, and you could benefit from:',
  offerFeatures: {
    default: () => [
      'Reduce upfront costs',
      'Fast offers',
      'Tax relief options',
      'Terms from 1-7 years',
      'Competitive pricing',
      'Spread costs over the lifetime of the asset'
    ]
  }
};
